import React from "react";
import { Typography } from "antd";
import { AppleOutlined, ArrowRightOutlined } from "@ant-design/icons";

const { Text } = Typography;

export const AZUL_BIWO = "#00BFD6";
export const AZUL_BIWO_BG = "#e6f8fb";
export const LIMA_BIWO = "#C9DF00";
export const LIMA_BIWO_BG = "#f8fce6";

const MAX_ICONOS = 8;

const renderIconos = (cantidad, color) => {
  const cantidadNum = Math.max(0, Math.round(cantidad) || 0);
  const mostrar = Math.min(cantidadNum, MAX_ICONOS);
  const iconos = [];
  for (let i = 0; i < mostrar; i++) {
    iconos.push(<AppleOutlined key={i} style={{ fontSize: 16, color }} />);
  }
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        justifyContent: "center",
        minHeight: 20,
      }}
    >
      {iconos}
      {cantidadNum > MAX_ICONOS && (
        <Text style={{ fontSize: 12, color }}>+{cantidadNum - MAX_ICONOS}</Text>
      )}
    </div>
  );
};

export const Caja = ({ titulo, cantidad, unidad, color, fondo }) => (
  <div
    style={{
      padding: "8px 6px",
      backgroundColor: fondo,
      border: `1px solid ${color}`,
      borderRadius: 6,
      textAlign: "center",
      width: 115,
      boxSizing: "border-box",
      overflow: "hidden",
    }}
  >
    <Text style={{ fontSize: 11, color, display: "block", marginBottom: 4 }}>
      {titulo}
    </Text>
    {renderIconos(cantidad, color)}
    <Text strong style={{ fontSize: 15, display: "block", marginTop: 4 }}>
      {cantidad}
    </Text>
    <Text
      style={{
        fontSize: 12,
        color: "#595959",
        display: "block",
        wordBreak: "break-word",
      }}
    >
      {unidad}
    </Text>
  </div>
);

const DiagramaConversion = ({ cajaA, cajaB, factorTexto, notaTexto, width = 280 }) => (
  <div style={{ width }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        marginBottom: 10,
      }}
    >
      <Caja {...cajaA} />
      <ArrowRightOutlined style={{ fontSize: 16, color: "#8c8c8c" }} />
      <Caja {...cajaB} />
    </div>

    {factorTexto && (
      <Text type="secondary" style={{ fontSize: 12, display: "block", textAlign: "center" }}>
        {factorTexto}
      </Text>
    )}

    {notaTexto && (
      <Text
        type="secondary"
        style={{ fontSize: 12, display: "block", textAlign: "center", marginTop: 4 }}
      >
        {notaTexto}
      </Text>
    )}
  </div>
);

export default DiagramaConversion;
